import { render, staticRenderFns } from "./SearchResultRowSimple.vue?vue&type=template&id=bb8f85a0&scoped=true"
import script from "./SearchResultRowSimple.vue?vue&type=script&lang=js"
export * from "./SearchResultRowSimple.vue?vue&type=script&lang=js"
import style0 from "./SearchResultRowSimple.vue?vue&type=style&index=0&id=bb8f85a0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bb8f85a0",
  null
  
)

export default component.exports